export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  VIEWER: 'viewer',
};

export const ROLE_ORDER = { admin: 3, manager: 2, viewer: 1 };

export const MANUAL_CATEGORIES = [
  { value: 'lead', label: 'Lead' },
  { value: 'deal', label: 'Deal' },
  { value: 'revenue', label: 'Revenue' },
  { value: 'job', label: 'Job' },
  { value: 'other', label: 'Other' },
];

export const COLORS = {
  primary: '#6366f1',
  success: '#22c55e',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  muted: '#94a3b8',
  ghl: '#6366f1',
  servicetitan: '#f59e0b',
  manual: '#22c55e',
};

export const CHART_COLORS = [
  '#6366f1', '#22c55e', '#f59e0b', '#ef4444', '#3b82f6',
  '#a855f7', '#14b8a6', '#f97316', '#ec4899', '#06b6d4',
];
